import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import {
  Navbar,
  Nav,
  Container,
  Button,
  Collapse,
  Offcanvas,
  Badge,
} from 'react-bootstrap'
import {
  Bell,
  People,
  PersonPlus,
  List,
  Person,
  Book,
  ClipboardCheck,
  CalendarCheck,
  CalendarMinus,
  Building,
  ChevronDown,
  ChevronUp,
  ChevronLeft,
  ChevronRight,
  BoxArrowRight,
  ChatDots,
  CreditCard,
  PersonBadge,
  Printer,
  FileEarmarkText,
  JournalBookmark,
  Award,
  ClipboardData,
  CurrencyRupee,
  QuestionCircle,
} from 'react-bootstrap-icons'
import { Link, useLocation } from 'react-router-dom'
import {
  FaArchive,
  FaClipboardList,
  FaCog,
  FaExchangeAlt,
  FaExclamationTriangle,
  FaEye,
  FaFileInvoice,
  FaLock,
  FaMapMarkerAlt,
  FaBus,
  FaPenAlt,
  FaSchool,
  FaTachometerAlt,
  FaUnlockAlt,
  FaUser,
  FaUserAlt,
  FaUserGraduate,
  FaUserMinus,
  FaUserShield,
  FaUserSlash,
} from 'react-icons/fa'

import {
  FaBook,
  FaBookOpen,
  FaChalkboard,
  FaChalkboardTeacher,
  FaUniversity,
  FaUserTie,
  FaGraduationCap,
} from 'react-icons/fa'
import Cookies from 'js-cookie'
import { useAuth } from './AuthContext'
import { clearAuthCookies } from '../utils/instituteIdCookie'
import { Settings } from 'react-feather'
import NewInstituteSelectionModal from './NewInstituteSelectionModal'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import { useSidebar } from './SidebarContext'
import SidebarToggle from './commonComponents/SidebarToggle'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { useSubscriptionNeedPlan } from './commonComponents/SubscriptionNeedPlanContext'

export default function Sidenavbar() {
  const location = useLocation()
  const [openDropdown, setOpenDropdown] = useState('')
  const [instituteName, setinstituteName] = useState('')
  const [show, setShow] = useState(false)
  const [notifications, setNotifications] = useState(3)
  // const [user, setUser] = useState(null) // ✅ Set default value to `null`
  const { logout, user } = useAuth()

  const handleLogout = () => {
    clearAuthCookies()
    logout()
  }
  const [showModal, setShowModal] = useState(false);
  const { isCollapsed, toggleSidebar } = useSidebar()
  const { logo, name, id, type: instituteTypeFromContext } = useInstitute();
  const instituteFullName =
    name || instituteName || 'Institute'
  const instituteFullNameTitle = instituteFullName
  const instituteDisplayLabel =
    instituteFullName.length > 20
      ? `${instituteFullName.slice(0, 20)}...`
      : instituteFullName
  const instituteNameTextStyle = {
    margin: 0,
    fontWeight: '600',
    color: '#111827',
    whiteSpace: 'nowrap',
    fontFamily: 'Inter, system-ui, sans-serif',
    maxWidth: '100%',
  }
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const navigate = useNavigate()
  // Route to parent menu mapping
  const routeToParentMenu = {
    '/Dashboard': '',
    '/students': 'students',
    '/student/add': 'students',
    '/student/discharged': 'students',
    '/PassedOutStudent': 'students',
    '/TeacherStudent': 'teacherstudents',
    '/AddCourse': 'courseList',
    '/AddSubject': 'courseList',
    '/AddClass': 'classes',
    '/ClassList': 'classes',
    '/FeeStructure': 'feesManagement',
    '/ApplyFees': 'feesManagement',
    '/TakeFees': 'feesManagement',
    '/ManageStudentFees': 'feesManagement',
    '/FeeUpdateLogs': 'feesManagement',
    '/FeeChangeLogs': 'feesManagement',
    '/FeeCollection': 'feesManagement',
    '/PendingFee': 'feesManagement',
    '/AddInstitute': 'institute',
    '/TakeAttendance': 'attendance',
    '/ViewAttendance': 'attendance',
    '/TeacherList': 'teacher',
    '/LeftTeachers': 'teacher',
    '/TakeTeacherAttendance': 'teacher',
    '/ViewTeacherAttendance': 'teacher',
    '/MyAttendance': 'myattendance',
    '/TakeLeave': 'takeleave',
    '/ViewLeave': 'teacher',
    '/AddNewTeacher': 'teacher',
    '/AssignClass': 'teacher',
    '/AddUser': 'user',
    '/AddGuardian': 'guardian',
    '/EnquiryForm': 'enquiry',
    '/AddNewEnquiry': 'enquiry',
    '/ExamSheet': 'examMarksheet',
    '/ExamSheet/Add': 'examMarksheet',
    '/ExamSheet/Admitcard': 'examMarksheet',
    '/ExamSheet/BulkAdmitcard': 'examMarksheet',
    '/ExamMarksheet': 'examMarksheet',
    '/AddExamResult': 'examMarksheet',
    '/Certificate': 'certificate',
    '/certificate/template1': 'certificate',
    '/certificate/template2': 'certificate',
    '/certificate/template3': 'certificate',
    '/certificate/template4': 'certificate',
    '/certificate/template5': 'certificate',
    '/certificate/template6': 'certificate',
    '/certificate/template7': 'certificate',
    '/certificate/template8': 'certificate',
    '/GenerateTC': 'certificate',
    '/TransferCertificate': 'certificate',
    '/TemplateBasedCertificate': 'certificate',
    '/Templates': '',
    '/EditTemplate': '',
    '/ManageHolidays': 'holiday',
    '/CreateHoliday': 'holiday',
    '/ChangePassword': '',
    '/Settings': '',
    '/parent/student/list': '',
    '/parent/dashboard': '',
    '/parent/homework': '',
    '/parent/homework': '',
    '/parent/holidays': '',
    '/parent/holidays': '',
    '/updates': '',
    '/parent/raise-query': 'support',
    '/Notifications': 'notification',
    '/Announcements': 'notification',
    '/announcements': 'notification',
    '/TopAnnouncements': 'topannouncements',
    '/parent/top-announcements': 'topannouncements',
    '/announcement/create': 'notification',
    '/CreateNotification': 'notification',
    '/CreateAnnouncement': 'notification',
    '/homework': 'homework',
    '/Homework': 'homework',
    '/homework/create': 'homework',
    '/Homework/create': 'homework',
    '/Transport': 'transport',
    '/CreateBus': 'transport',
    '/AssignBusToStudent': 'transport',
    '/ViewBusAssignedStd': 'transport',
    '/TrackVehicle': 'transport',
    '/admin/subscription': '',
    '/admin/subscription/plans': '',
    '/admin-parent-queries': '',
  }

  const isSubscriptionActive = () =>
    location.pathname === '/admin/subscription' ||
    location.pathname === '/admin/subscription/plans'
  
  // Check if IDcard route is active and determine source
  const getIDcardSource = () => {
    if (location.pathname.includes('/student/id-card/')) {
      return location.state?.fromPassedOutStudents 
        ? 'passedOut' 
        : location.state?.fromLeftStudents 
        ? 'left' 
        : 'active'
    }
    return null
  }
  
  // Check if StudentProfile route is active and determine source
  const getStudentProfileSource = () => {
    if (location.pathname.includes('/student/profile/')) {
      return location.state?.fromPassedOutStudents 
        ? 'passedOut' 
        : 'active'
    }
    return null
  }
  
  // Check if DischargedStdProfile route is active
  const isDischargedStdProfileActive = () => {
    return location.pathname.includes('/student/discharged/profile/')
  }

  // Get active parent menu based on current route
  const getActiveParentMenu = () => {
    const currentPath = location.pathname
    // Check for dynamic routes
    if (currentPath.includes('/Assign/UserRole')) {
      return 'user'
    }
    if (currentPath.startsWith('/TransferCertificate/')) {
      return 'certificate'
    }
    // View page matches TopAnnouncements nav (not Create Announcement submenu)
    if (currentPath.startsWith('/announcement/view/')) {
      return ''
    }
    if (currentPath === '/announcements' || currentPath.startsWith('/announcement/')) {
      return 'notification'
    }
    if (currentPath === '/homework' || currentPath.startsWith('/homework/') || currentPath.startsWith('/Homework')) {
      return 'homework'
    }
    if (currentPath.startsWith('/EditHoliday/')) {
      return 'holiday'
    }
    if (currentPath.startsWith('/ExamSheet/schedule/')) {
      return 'examMarksheet'
    }
    if (currentPath === '/ExamSheet/Add') {
      return 'examMarksheet'
    }
    if (currentPath === '/ExamSheet/Admitcard' || currentPath.startsWith('/ExamSheet/Admitcard/')) {
      return 'examMarksheet'
    }
    if (currentPath === '/ExamSheet/BulkAdmitcard' || currentPath.startsWith('/ExamSheet/BulkAdmitcard/')) {
      return 'examMarksheet'
    }
    if (currentPath === '/FeeUpdateLogs' || currentPath.startsWith('/FeeChangeLogs/')) {
      return 'feesManagement'
    }
    return routeToParentMenu[currentPath] || ''
  }

  const activeParentMenu = getActiveParentMenu()
  const normalizedUserType = (user?.user_type || '').toLowerCase()
  const normalizedRoles = (user?.roles || []).map((role) => String(role).toLowerCase())
  const isAdminUser = normalizedUserType === 'admin' || normalizedRoles.includes('admin')
  const isAccountantUser =
    normalizedUserType === 'accountant' || normalizedRoles.includes('accountant')
  const isSuperAdminUser =
    normalizedUserType === 'superadmin' || normalizedRoles.includes('superadmin')
  const isFeesCollectorUser =
    ['fee_collector', 'fees_collector'].includes(normalizedUserType) ||
    normalizedRoles.includes('fee_collector') ||
    normalizedRoles.includes('fees_collector')
  const isFeesCollectorOnly = isFeesCollectorUser && !isAdminUser
  const canAccessFullFeesManagement = isAdminUser || isAccountantUser || isSuperAdminUser
  const canAccessFeesManagement = canAccessFullFeesManagement || isFeesCollectorOnly
  const canAccessCollectorLimitedFees =
    canAccessFullFeesManagement || isFeesCollectorOnly

  const isBusAttendantRole =
    normalizedUserType === 'bus_attendant' ||
    normalizedRoles.includes('bus_attendant')
  // Prefer context/cookie over AuthContext user — institute switch updates those first.
  const instituteType = String(
    instituteTypeFromContext ||
      Cookies.get('institute_type') ||
      user?.institute_type ||
      '',
  )
    .trim()
    .toLowerCase()
  const isCoachingInstitute = instituteType === 'coaching'
  const showTransportNavSection =
    (isAdminUser || isBusAttendantRole) && !isCoachingInstitute
  const showCertificateNavSection = isAdminUser && !isCoachingInstitute
  const isAttendantOnlyUser = isBusAttendantRole && !isAdminUser

  /** Fine-grained menu permissions (assigned via Assign User Role). */
  const hasPermission = (key) =>
    normalizedRoles.includes(key) || normalizedUserType === key
  const canManageStudentsNav = isAdminUser || hasPermission('manage_student')
  const canManageCoursesNav = isAdminUser || hasPermission('manage_courses')
  const canManageClassesNav = isAdminUser || hasPermission('manage_classes')
  const canManageGuardiansNav = isAdminUser || hasPermission('manage_guardians')
  const canManageAnnouncementsNav =
    isAdminUser || hasPermission('manage_announcements')
  const canManageExamsNav =
    isAdminUser ||
    normalizedUserType === 'teacher' ||
    normalizedRoles.includes('teacher') ||
    hasPermission('manage_exams')
  const showExamManagementNavSection =
    canManageExamsNav && !isCoachingInstitute
  const canAccessHomeworkNav =
    isAdminUser ||
    normalizedUserType === 'teacher' ||
    normalizedRoles.includes('teacher')
  const canCreateHomeworkNav =
    normalizedUserType === 'teacher' || normalizedRoles.includes('teacher')
  const isTeacherPortalUser =
    (normalizedUserType === 'teacher' || normalizedRoles.includes('teacher')) &&
    !isAdminUser
  const isParentPortalUser =
    normalizedUserType === 'parents' || normalizedUserType === 'parent'
  const { needPlan } = useSubscriptionNeedPlan()
  const subscriptionOnlyMode = needPlan === true

  // Check if a route is active
  const isRouteActive = (route) => {
    return location.pathname === route
  }

  const isExamSheetManageActive = () =>
    location.pathname === '/ExamSheet' ||
    location.pathname === '/ExamSheet/Add' ||
    location.pathname.startsWith('/ExamSheet/schedule/')

  const isHomeworkListActive = () =>
    isRouteActive('/homework') ||
    isRouteActive('/Homework') ||
    location.pathname.startsWith('/homework/edit/') ||
    location.pathname.startsWith('/Homework/edit/')

  const isHomeworkCreateActive = () =>
    isRouteActive('/homework/create') || isRouteActive('/Homework/create')

  // Check if any of the provided routes is active (exact match)
  const isAnyRouteActive = (routes = []) => {
    return routes.includes(location.pathname)
  }

  // Notification / Announcement create pages (list page + form page)
  const isCreateNotificationActive = () =>
    isAnyRouteActive(['/Notifications', '/CreateNotification'])

  const isCreateAnnouncementActive = () => {
    const p = location.pathname
    return (
      ['/Announcements', '/CreateAnnouncement', '/announcements', '/announcement/create'].includes(p) ||
      p.startsWith('/announcement/edit/')
    )
  }

  const isTopAnnouncementsActive = () =>
    isRouteActive('/TopAnnouncements') ||
    isRouteActive('/parent/top-announcements') ||
    location.pathname.startsWith('/announcement/view/')

  const topAnnouncementsHref = isParentPortalUser
    ? '/parent/top-announcements'
    : '/TopAnnouncements'

  // Transport (Manage Transport list page + Create Bus form page)
  const isManageBusActive = () =>
    isAnyRouteActive([
      '/Transport',
      '/CreateBus',
      '/AssignBusToStudent',
      '/ViewBusAssignedStd',
    ])

  const isAttendantPortalActive = () => isRouteActive('/AttendantPortal')

  // Check if AddStudent route is active (including AddNewStudent, IDcard, and StudentProfile from Active Students)
  const isAddStudentActive = () => {
    const idcardSource = getIDcardSource()
    const studentProfileSource = getStudentProfileSource()
    return location.pathname === '/students' || 
           location.pathname === '/student/add' ||
           location.pathname.includes('/student/enrolled-courses/') ||
           (location.pathname.includes('/student/id-card/') && idcardSource === 'active') ||
           (location.pathname.includes('/student/profile/') && studentProfileSource === 'active')
  }
  
  // Check if DischargedStudent route is active (including IDcard from Left Students and DischargedStdProfile)
  const isDischargedStudentActive = () => {
    const idcardSource = getIDcardSource()
    return location.pathname === '/student/discharged' ||
           (location.pathname.includes('/student/id-card/') && idcardSource === 'left') ||
           isDischargedStdProfileActive()
  }
  
  // Check if PassedOutStudent route is active (including IDcard and StudentProfile from Passed Out Students)
  const isPassedOutStudentActive = () => {
    const idcardSource = getIDcardSource()
    const studentProfileSource = getStudentProfileSource()
    return location.pathname === '/PassedOutStudent' ||
           (location.pathname.includes('/student/id-card/') && idcardSource === 'passedOut') ||
           (location.pathname.includes('/student/profile/') && studentProfileSource === 'passedOut')
  }

  // Check if EnquiryForm route is active (including AddNewEnquiry)
  const isEnquiryActive = () => {
    return location.pathname === '/EnquiryForm' || location.pathname === '/AddNewEnquiry'
  }

  // Check if TeacherList route is active (including AddNewTeacher)
  const isTeacherListActive = () => {
    return location.pathname === '/TeacherList' || location.pathname === '/AddNewTeacher'
  }

  const isLeftTeachersActive = () => {
    return (
      location.pathname === '/LeftTeachers' ||
      (location.pathname.includes('/TeacherProfile/') &&
        location.state?.fromLeftTeachers)
    )
  }

  // Check if parent menu has active child
  const hasActiveChild = (parentMenu) => {
    return activeParentMenu === parentMenu
  }

  const mobileOffcanvasActive = (isActive) =>
    isActive ? 'mobile-offcanvas-link-active' : ''

  const mobileMatchPath = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`)

  const isMobileSettingsActive = () =>
    location.pathname === '/settings' || location.pathname === '/Settings'

  const isMobileCertificateGenerateActive = () =>
    location.pathname === '/Certificate' ||
    (location.pathname.startsWith('/Certificate/') &&
      !location.pathname.toLowerCase().startsWith('/certificate/template'))

  // useEffect(() => {
  //   const userLogged = Cookies.get('user')
  //   console.log('userLogged', userLogged)
  //   if (userLogged) {
  //     try {
  //       setUser(JSON.parse(userLogged))
  //       console.log('User:', JSON.parse(userLogged))
  //     } catch (error) {
  //       console.error('Error parsing user data:', error)
  //       Cookies.remove('user') // ✅ Remove invalid cookie
  //     }
  //   }
  // }, [])
  useEffect(() => {
    const institute_name = Cookies.get('name')
    setinstituteName(institute_name || name)
  }, [name])

  const toggleDropdown = (dropdown) => {
    // Don't allow dropdown toggling when sidebar is collapsed
    if (isCollapsed) return
    setOpenDropdown(openDropdown === dropdown ? '' : dropdown)
  }

  // Auto-open parent menu when its child route is active (only when expanded)
  useEffect(() => {
    if (!isCollapsed && activeParentMenu) {
      setOpenDropdown(activeParentMenu)
    }
  }, [location.pathname, isCollapsed, activeParentMenu])

  // Close all dropdowns when sidebar collapses
  useEffect(() => {
    if (isCollapsed) {
      setOpenDropdown('')
    }
  }, [isCollapsed])

  // const { user } = useAuth()
  // console.log('User Data are : ', user)

  return (
    <>
      <style>
        {`
          /* Scrollbar styling for sidebar */
          .sidebar-scrollable::-webkit-scrollbar {
            width: 6px;
          }
          .sidebar-scrollable::-webkit-scrollbar-track {
            background: transparent;
          }
          .sidebar-scrollable::-webkit-scrollbar-thumb {
            background: #D1D3D4;
            border-radius: 3px;
          }
          .sidebar-scrollable::-webkit-scrollbar-thumb:hover {
            background: #9ca3af;
          }

          /* Force sidebar background color.
             Expanded width is locked: Bootstrap w-auto uses width:auto !important and
             otherwise shrink-wraps past 245px when a submenu (e.g. Create Announcement) is open. */
          .flex-column.shadow.w-auto,
          .flex-column.shadow.w-auto.navbar,
          .navbar.flex-column {
            background-color: #F3F4F6 !important;
            background: #F3F4F6 !important;
            border-right: 1px solid #D1D3D4;
          }

          .navbar.flex-column.shadow:not(.sidebar-collapsed) {
            width: 245px !important;
            max-width: 245px !important;
          }
          
          /* Ensure Container inside sidebar also has the background */
          .navbar.flex-column .container-fluid,
          .navbar.flex-column .container {
            background-color: transparent !important;
          }

          .sidebar-collapsed {
            width: 85px !important;
            padding: 0.5rem 0.25rem !important;
          }

          /* Modern Menu Button Styles */
          .sidebar-menu-btn {
            background-color: transparent !important;
            border: none !important;
            color: #6b7280 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            padding: 10px 12px !important;
            margin: 2px 0 !important;
            border-radius: 8px !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            width: 100% !important;
            text-align: left !important;
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            font-family: 'Inter', system-ui, sans-serif !important;
            box-sizing: border-box !important;
          }

          .sidebar-menu-btn > .d-flex.align-items-center {
            display: flex !important;
            align-items: center !important;
            min-width: 0 !important;
          }

          .sidebar-menu-btn > .d-flex.align-items-center > svg {
            width: 20px !important;
            min-width: 20px !important;
            height: 20px !important;
            margin-right: 12px !important;
            flex-shrink: 0 !important;
          }

          .sidebar-collapsed .sidebar-menu-btn > .d-flex.align-items-center > svg {
            margin-right: 0 !important;
          }

          .sidebar-menu-btn:hover {
            background-color: #ffffff !important;
            color: #111827 !important;
            transform: translateX(2px);
          }

          .sidebar-menu-btn.active {
            background-color: #ffffff !important;
            color: #223843 !important;
            font-weight: 600 !important;
            border-left: 3px solid #223843 !important;
            padding-left: 9px !important;
          }

          .sidebar-menu-btn.active svg {
            color: #223843 !important;
          }

          .sidebar-menu-btn svg {
            transition: all 0.2s ease !important;
          }

          .sidebar-menu-btn:hover svg {
            color: #223843 !important;
          }

          /* Active state for collapsed sidebar - highlight icon */
          .sidebar-collapsed .sidebar-menu-btn.active {
            background-color: #ffffff !important;
            border-left: 3px solid #223843 !important;
          }

          .sidebar-collapsed .sidebar-menu-btn.active svg {
            color: #223843 !important;
          }

          .subscription-only-nav .sidebar-menu-btn:not(.subscription-nav-item),
          .subscription-only-nav .sidebar-child-link,
          .subscription-only-nav .nav-link:not(.subscription-nav-item) {
            display: none !important;
          }

          .mobile-offcanvas-sidebar .subscription-only-nav button:not(.subscription-nav-item),
          .mobile-offcanvas-sidebar .subscription-only-nav a.nav-link:not(.subscription-nav-item) {
            display: none !important;
          }

          /* Child Menu Link Styles */
          .sidebar-child-link {
            color: #6b7280 !important;
            font-size: 13px !important;
            font-weight: 400 !important;
            padding: 8px 12px 8px 40px !important;
            margin: 1px 0 !important;
            border-radius: 6px !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            display: flex !important;
            align-items: center !important;
            text-decoration: none !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }

          .sidebar-child-link:hover {
            background-color: #ffffff !important;
            color: #223843 !important;
            transform: translateX(2px);
          }

          .sidebar-child-link.active {
            background-color: #EFF6FF !important;
            color: #223843 !important;
            font-weight: 600 !important;
            border-left: 3px solid #223843 !important;
            padding-left: 37px !important;
          }

          .sidebar-child-link.active svg {
            color: #223843 !important;
          }

          .sidebar-child-link svg {
            margin-right: 10px !important;
            font-size: 16px !important;
            transition: all 0.2s ease !important;
          }

          /* Collapsed Sidebar Styles */
          .sidebar-collapsed .nav-button-text {
            display: none !important;
          }

          .sidebar-collapsed .btn {
            font-size: 0 !important;
            justify-content: center !important;
            text-align: center !important;
            width: 100% !important;
            padding: 10px !important;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }

          .sidebar-collapsed .btn svg {
            font-size: 20px !important;
            margin-right: 0 !important;
            margin-left: 0 !important;
          }

          .sidebar-collapsed .btn > span:not(:has(svg)),
          .sidebar-collapsed .btn span span,
          .sidebar-collapsed .btn span:not(:has(svg)) {
            display: none !important;
          }

          .sidebar-collapsed .btn svg:last-child:not(:first-child),
          .sidebar-collapsed .btn > svg:last-child:not(:first-child) {
            display: none !important;
          }

          .sidebar-collapsed .btn .d-flex {
            justify-content: center !important;
            width: 100% !important;
          }

          .sidebar-collapsed .dropdown-toggle::after {
            display: none !important;
          }

          .sidebar-collapsed .nav-link {
            justify-content: center !important;
            padding: 8px !important;
            font-size: 0 !important;
          }

          .sidebar-collapsed .nav-link svg {
            font-size: 18px !important;
            margin-right: 0 !important;
            margin-left: 0 !important;
          }

          .sidebar-collapsed .nav-link span:not(:has(svg)),
          .sidebar-collapsed .nav-link > *:not(svg) {
            display: none !important;
          }

          .sidebar-collapsed .collapse .nav-link {
            font-size: 0 !important;
          }

          .sidebar-collapsed .collapse .nav-link svg {
            font-size: 18px !important;
          }

          /* Desktop sidebar collapse/expand toggle */
          .sidebar-toggle-btn {
            width: 44px;
            height: 44px;
            min-width: 44px;
            border-radius: 12px;
            background: linear-gradient(145deg, #ffffff 0%, #f3f4f6 100%);
            border: 1px solid rgba(34, 56, 67, 0.12);
            color: #223843;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-shrink: 0;
            padding: 0;
            box-shadow:
              0 2px 8px rgba(34, 56, 67, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.9);
            transition:
              background 0.2s ease,
              color 0.2s ease,
              border-color 0.2s ease,
              transform 0.2s ease,
              box-shadow 0.2s ease;
          }

          .sidebar-toggle-btn:hover {
            background: #223843;
            color: #ffffff;
            border-color: #223843;
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(34, 56, 67, 0.22);
          }

          .sidebar-toggle-btn:active {
            transform: translateY(0);
            box-shadow: 0 2px 6px rgba(34, 56, 67, 0.18);
          }

          .sidebar-toggle-btn:focus-visible {
            outline: 2px solid #223843;
            outline-offset: 2px;
          }

          .sidebar-collapsed .sidebar-toggle-btn {
            margin: 0 auto;
            font-size: initial !important;
            width: 44px !important;
            height: 44px !important;
            min-width: 44px !important;
            padding: 0 !important;
            justify-content: center !important;
          }

          .sidebar-collapsed .sidebar-toggle-btn svg {
            font-size: 22px !important;
            margin: 0 !important;
          }

          /* Mobile top bar menu toggle */
          .mobile-menu-toggle {
            margin-left: max(12px, env(safe-area-inset-left, 0px));
            width: 44px;
            height: 44px;
            min-width: 44px;
            border: none;
            border-radius: 12px;
            background: linear-gradient(145deg, #ffffff 0%, #f3f4f6 100%);
            color: #223843;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-shrink: 0;
            padding: 0;
            box-shadow:
              0 2px 10px rgba(34, 56, 67, 0.12),
              0 0 0 1px rgba(34, 56, 67, 0.08);
            transition:
              background 0.2s ease,
              color 0.2s ease,
              transform 0.2s ease,
              box-shadow 0.2s ease;
          }

          .mobile-menu-toggle:hover {
            background: #223843;
            color: #ffffff;
            transform: translateY(-1px);
            box-shadow: 0 6px 16px rgba(34, 56, 67, 0.22);
          }

          .mobile-menu-toggle:active {
            transform: translateY(0);
          }

          .mobile-menu-toggle:focus-visible {
            outline: 2px solid #223843;
            outline-offset: 2px;
          }

          .mobile-top-navbar {
            min-height: var(--mobile-topbar-height, 56px);
            border-bottom: 1px solid rgba(34, 56, 67, 0.1);
            box-shadow: 0 4px 16px rgba(34, 56, 67, 0.06);
          }

          .mobile-top-navbar .container-fluid {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 12px;
            min-height: 48px;
            padding-right: max(12px, env(safe-area-inset-right, 0px)) !important;
          }

          /* Smooth transitions */
          .flex-column > * {
            transition: opacity 0.3s ease, transform 0.3s ease;
          }

          .flex-column img {
            transition: opacity 0.3s ease, transform 0.3s ease, height 0.3s ease, width 0.3s ease;
          }

          .flex-column p,
          .flex-column div {
            transition: opacity 0.3s ease, max-height 0.3s ease;
          }

          .sidebar-collapsed button[title],
          .sidebar-collapsed a[title] {
            position: relative;
          }

          .sidebar-collapsed .btn {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }

          /* Collapse animation */
          .collapse {
            transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }

          /* Switch Institute Button Modern Style */
          .switch-institute-btn {
            background-color: #ffffff !important;
            border: 1px solid #D1D3D4 !important;
            color: #223843 !important;
            font-size: 12px !important;
            font-weight: 600 !important;
            padding: 8px 12px !important;
            border-radius: 8px !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            width: 100% !important;
            margin-top: 8px !important;
            font-family: 'Inter', system-ui, sans-serif !important;
          }

          .switch-institute-btn:hover {
            background-color: #223843 !important;
            color: #ffffff !important;
            border-color: #223843 !important;
            transform: translateY(-1px);
            box-shadow: 0 2px 4px rgba(37, 99, 235, 0.2);
          }

          .switch-institute-btn svg {
            font-size: 14px !important;
          }

          .sidebar-collapsed .switch-institute-btn {
            justify-content: center !important;
            padding: 10px !important;
            min-width: 40px !important;
            width: 40px !important;
            margin: 8px auto !important;
          }

          .sidebar-collapsed .switch-institute-btn span {
            display: none !important;
          }

          /* Full-width mobile sidebar on all device widths (Bootstrap default is 400px) */
          .mobile-offcanvas-sidebar.offcanvas,
          .mobile-offcanvas-sidebar.offcanvas-start,
          .mobile-offcanvas-sidebar {
            --bs-offcanvas-width: 100vw;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            bottom: 0 !important;
            width: 100vw !important;
            max-width: 100% !important;
            height: 100dvh !important;
            margin: 0 !important;
          }

          .mobile-offcanvas-sidebar .offcanvas-body .nav {
            width: 100% !important;
            max-width: 100% !important;
          }

          .mobile-offcanvas-sidebar .offcanvas-header .btn-close {
            margin-left: -1rem !important;
          }

          .mobile-offcanvas-sidebar .mobile-offcanvas-link-active {
            color: #223843 !important;
            font-weight: 600 !important;
          }

          .mobile-offcanvas-sidebar .mobile-offcanvas-link-active svg {
            color: #223843 !important;
          }
        `}
      </style>
      <Navbar
        expand="lg"
        className="d-lg-none fixed-top mobile-top-navbar"
        style={{
          top: 0,
          left: 0,
          right: 0,
          width: '100%',
          zIndex: 1000,
          backgroundColor: '#F3F4F6',
          paddingTop: 'max(6px, env(safe-area-inset-top, 0px))',
          paddingBottom: '6px',
        }}
      >
        <Container fluid>
          <button
            type="button"
            className="mobile-menu-toggle"
            onClick={() => setShow(true)}
            aria-label="Open navigation menu"
            aria-expanded={show}
          >
            <List size={24} />
          </button>

          {/* Notifications and Profile Icons - Mobile View */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              flexShrink: 0,
            }}
          >
            <ProfileDropdown logout={handleLogout} notificationCount={notifications} showNotifications={true} />
          </div>
        </Container>
      </Navbar>

          <Offcanvas
            show={show}
            onHide={() => setShow(false)}
            placement="start"
            className="no-print mobile-offcanvas-sidebar d-lg-none"
            backdrop={true}
            style={{ zIndex: 1300 }}
          >
            <Offcanvas.Header style={{ borderBottom: '1px solid #D1D3D4', paddingBottom: '10px', position: 'relative' }}>
            <button
              onClick={() => setShow(false)}
              style={{
                position: 'absolute',
                top: '20%',
                right: '2px',
                background: 'transparent',
                border: 'none',
                fontSize: '3rem',
                color: '#223843',
                cursor: 'pointer',
                zIndex: 9999,
                lineHeight: '1'
              }}
            >
              &times;
            </button>
              {/* Modern Institute Info Card for Mobile - Compact Design */}
              {user && (
                <div style={{ width: '100%', paddingRight: '40px' }}>
                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '8px',
                      border: '1px solid #D1D3D4',
                      padding: '8px 10px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
                    }}
                    title={instituteFullNameTitle}
                  >
                    {/* Institute Icon */}
                    <div
                      style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        backgroundColor: '#223843',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                      title={instituteFullNameTitle}
                    >
                      <img
                        src={logo}
                        alt="Institute Logo"
                        title={instituteFullNameTitle}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                      {/* <FaSchool size={12} style={{ color: '#ffffff' }} /> */}
                    </div> 
                    
                    {/* Institute Name */}
                    <div
                      style={{ flex: 1, minWidth: 0 }}
                      title={instituteFullNameTitle}
                    >
                      <p
                        style={{
                          ...instituteNameTextStyle,
                          fontSize: '12px',
                          lineHeight: '1.2',
                        }}
                        title={instituteFullNameTitle}
                      >
                        {instituteDisplayLabel}
                      </p>
                      <p
                        style={{
                          margin: 0,
                          fontSize: '9px',
                          color: '#6b7280',
                          fontWeight: '400',
                          marginTop: '1px',
                          lineHeight: '1.1',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                      >
                        Current Institute
                      </p>
                    </div>
                  </div>
                  
                  {/* Switch Institute Button - Compact Design (always for admin, incl. no-subscription) */}
                  {user?.user_type == "admin" && (
                    <Button
                      variant="link"
                      onClick={handleOpenModal}
                      className="no-print"
                      style={{
                        width: '100%',
                        backgroundColor: '#F3F4F6',
                        border: '1px solid #D1D3D4',
                        color: '#223843',
                        fontSize: '11px',
                        fontWeight: '600',
                        padding: '6px 12px',
                        borderRadius: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        textDecoration: 'none',
                        marginTop: '8px',
                        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        fontFamily: 'Inter, system-ui, sans-serif',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#223843'
                        e.currentTarget.style.color = '#ffffff'
                        e.currentTarget.style.borderColor = '#223843'
                        e.currentTarget.style.transform = 'translateY(-1px)'
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#F3F4F6'
                        e.currentTarget.style.color = '#223843'
                        e.currentTarget.style.borderColor = '#D1D3D4'
                        e.currentTarget.style.transform = 'translateY(0)'
                      }}
                    >
                      <FaExchangeAlt size={11} />
                      <span>Switch Institute</span>
                    </Button>
                  )}
                </div>
              )}
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column justify-content-between h-100">
              <Nav className={`flex-column w-100${subscriptionOnlyMode ? ' subscription-only-nav' : ''}`}>
                {subscriptionOnlyMode && !isAdminUser && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none mt-3 subscription-nav-item ${mobileOffcanvasActive(isSubscriptionActive())}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { navigate('/admin/subscription'); setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <CreditCard size={20} className="me-2" />
                      <span>Subscription</span>
                    </div>
                  </Button>
                )}
                {(user?.user_type == "admin" || user?.roles?.includes('admin') ) && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-3 ${mobileOffcanvasActive(isRouteActive('/Dashboard') || location.pathname === '/')}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/Dashboard')}
                  >
                    <div className="d-flex align-items-center">
                      <FaTachometerAlt size={20} className="me-2" />
                      <span>Dashboard</span>
                    </div>
                  </Button>
             )}
                {user?.user_type === 'parents' && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none mt-3 ${mobileOffcanvasActive(
                      isRouteActive('/parent/dashboard'),
                    )}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/parent/dashboard')}
                  >
                    <div className="d-flex align-items-center">
                      <FaTachometerAlt size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Dashboard</span>
                    </div>
                  </Button>
                )}

                {/* {user?.user_type === 'parents' && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/updates'))}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { window.location.href = '/updates'; setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <Bell size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Updates</span>
                    </div>
                  </Button>
                )} */}
              
               {!isFeesCollectorOnly && !isAttendantOnlyUser && <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isTopAnnouncementsActive() || location.pathname === '/')}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = topAnnouncementsHref)}
                  >
                    <div className="d-flex align-items-center">
                      <Bell size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Announcements</span>
                    </div>
                  </Button>}

              {canManageStudentsNav && (
                  <>
                  
                <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('students'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('students')}
                >
                  <span>
                    <Person size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'students' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'students'}>
                  <div>
                    <Link
                      to="/students"
                      className={`nav-link ps-4 text-black ${mobileOffcanvasActive(isAddStudentActive())}`}
                      onClick={() => setShow(false)}
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      Active Students
                    </Link>
                    <Link
                      to="/student/discharged"
                      className={`nav-link ps-4 text-black ${mobileOffcanvasActive(isDischargedStudentActive())}`}
                      onClick={() => setShow(false)}
                    >
                      <FaUserSlash /> Left Students
                    </Link>
                      <Link
                        to="/students/passed-out"
                        className={`nav-link ps-4 text-black ${mobileOffcanvasActive(isPassedOutStudentActive())}`}
                        onClick={() => setShow(false)}
                      >
                          <FaUserGraduate /> Passed Out Students
                      </Link>
                  </div>
                </Collapse>
                </>
                )}

                
              {(normalizedUserType === 'teacher' && !canManageStudentsNav) && (

                  <>
                  
                <Button
                  variant="dark"
                  className={`text-muted w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('teacherstudents'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('students')}
                >
                  <span>
                    <People size={20} className="me-2" /> Students
                  </span>
                  {openDropdown === 'students' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'students'}>
                  <div>
                    <Link
                      to="/TeacherStudent"
                      className={`nav-link text-muted ps-4 ${mobileOffcanvasActive(mobileMatchPath('/TeacherStudent'))}`}
                      onClick={() => setShow(false)}
                    >
                      <People
                        size={16}
                        className="me-2"
                        style={{ verticalAlign: 'middle' }}
                      />
                      Active Students
                    </Link>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/student/discharged"
                        className={`nav-link text-muted ps-4 ${mobileOffcanvasActive(isDischargedStudentActive())}`}
                        onClick={() => setShow(false)}
                      >
                        <FaUserSlash /> Left Students
                      </Link>
                    )}
                  </div>
                </Collapse>
                </>
                )}

                {/* Manage Courses Dropdown */}
                {canManageCoursesNav && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('courseList'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('courseList')}
                    >
                      <span>
                        <FaBookOpen size={20} className="me-2" /> Courses
                      </span>
                      {openDropdown === 'courseList' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'courseList'}>
                      <div>
                        <Link
                          to="/AddCourse"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AddCourse'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaBookOpen size={18} className="me-2" /> Manage Courses
                        </Link>
                        <Link
                          to="/AddSubject"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AddSubject'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaBookOpen size={18} className="me-2" /> Manage Subjects
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {canManageClassesNav && (
                  <>
                {/* Classes Dropdown */}
                <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('classes'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('classes')}
                >
                  <span>
                    <FaChalkboard size={20} className="me-2" /> Classes
                  </span>
                  {openDropdown === 'classes' ? <ChevronUp /> : <ChevronDown />}
              
                </Button>
                <Collapse in={openDropdown === 'classes'}>
                  <div>
                    <Link
                      to="/AddClass"
                      className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AddClass') || isRouteActive('/ClassList'))}`}
                      onClick={() => setShow(false)}
                    >
                      <FaChalkboard size={18} className="me-2" /> Manage Classes
                    </Link>
                  </div>
                </Collapse>
                </>
                )}
                 {canAccessFeesManagement && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('feesManagement'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('feesManagement')}
                    >
                      <span>
                        <CreditCard size={20} className="me-2" /> Fees
                        Management
                      </span>
                      {openDropdown === 'feesManagement' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'feesManagement'}>
                      <div>
                        {canAccessFullFeesManagement && (
                          <>
                            <Link
                              to="/FeeStructure"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/FeeStructure'))}`}
                              onClick={() => setShow(false)}
                            >
                              <CreditCard size={18} className="me-2" /> Fees
                              Structure
                            </Link>
                            <Link
                              to="/ApplyFees"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/ApplyFees'))}`}
                              onClick={() => setShow(false)}
                            >
                              <CreditCard size={18} className="me-2" />
                              Apply Fee
                            </Link>
                            <Link
                              to="/FeeCollection"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/FeeCollection'))}`}
                              onClick={() => setShow(false)}
                            >
                              <CurrencyRupee size={18} className="me-2" /> Fees
                              Collection
                            </Link>
                            <Link
                              to="/FeeUpdateLogs"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/FeeUpdateLogs'))}`}
                              onClick={() => setShow(false)}
                            >
                              <FaClipboardList size={18} className="me-2" /> Fee
                              Update Logs
                            </Link>
                          </>
                        )}
                        {canAccessCollectorLimitedFees && (
                          <>
                            <Link
                              to="/TakeFees"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/TakeFees'))}`}
                              onClick={() => setShow(false)}
                            >
                              <CurrencyRupee size={18} className="me-2" /> Take Fees
                            </Link>
                            <Link
                              to="/ManageStudentFees"
                              className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/ManageStudentFees'))}`}
                              onClick={() => setShow(false)}
                            >
                              <CurrencyRupee size={18} className="me-2" /> Fees
                              Status
                            </Link>
                          </>
                        )}
                        <Link
                          to="/PendingFee"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/PendingFee'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaExclamationTriangle size={18} className="me-2" /> Pending Fee
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}


                
                {user?.user_type === 'parents' && ( 
                   <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none mt-0 ${mobileOffcanvasActive(
                      location.pathname === '/parent/student/list' ||
                        location.pathname.startsWith('/parent/student/profile') ||
                        location.pathname.startsWith('/Student/Fees') ||
                        location.pathname.startsWith('/Student/Attendance')
                    )}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/parent/student/list')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Student's Profile</span>
                    </div>
                  </Button> 
               )}
                {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('institute'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('institute')}
                    >
                      <span>
                        <FaUniversity size={20} className="me-2" /> Institutes
                      </span>
                      {openDropdown === 'institute' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'institute'}>
                      <div>
                        <Link
                          to="/AddInstitute"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AddInstitute'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaUniversity size={18} className="me-2" /> Manage Institutes
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {/* Attendance Dropdown */}
                 {(isAdminUser || isTeacherPortalUser) && (
                  <>
                <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('attendance'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('attendance')}
                >
                  <span>
                    <ClipboardCheck size={20} className="me-2" /> Attendance
                  </span>
                  {openDropdown === 'attendance' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'attendance'}>
                  <div>
                    <Link
                      to="/TakeAttendance"
                      className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/TakeAttendance'))}`}
                      onClick={() => setShow(false)}
                    >
                      <CalendarCheck size={18} className="me-2" /> Take
                      Attendance
                    </Link>
                    
                      <Link
                        to="/ViewAttendance"
                        className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/ViewAttendance'))}`}
                        onClick={() => setShow(false)}
                      >
                        <FaEye size={18} className="me-2" /> View Attendance
                      </Link>
                  </div>
                </Collapse>
                  </>
                )}


                   {(user?.user_type == 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || user?.roles?.includes('teacher')) && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('teacher'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('teacher')}
                    >
                      <span>
                        <FaChalkboardTeacher size={20} className="me-2" /> Teachers
                      </span>
                      {openDropdown === 'teacher' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'teacher'}>
                      <div>
                        {(user?.user_type !== 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || !user?.roles?.includes('teacher')) && (
                        <Link
                          to="/TeacherList"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isTeacherListActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <FaChalkboardTeacher size={18} className="me-2" /> Manage Teachers
                        </Link>
                        )}
                        {(user?.user_type !== 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || !user?.roles?.includes('teacher')) && (
                        <Link
                          to="/LeftTeachers"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isLeftTeachersActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <FaUserSlash size={18} className="me-2" /> Left Teachers
                        </Link>
                        )}

                         <Link
                        to="/AssignClass"
                         className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AssignClass'))}`}
                          onClick={() => setShow(false)}
                      >
                        <FaUserTie size={18} className="me-2" />
                        Assign Class
                      </Link>
                      
                    {isTeacherPortalUser && (
                      <Link
                        to="/MyAttendance"
                        className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/MyAttendance'))}`}
                        onClick={() => setShow(false)}
                      >
                        <ClipboardCheck size={18} className="me-2" /> My Attendance
                      </Link>
                    )}
                     {isAdminUser && (
                      <>
                       <Link
                        to="/TakeTeacherAttendance"
                        className={`nav-link text-start text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/TakeTeacherAttendance'))}`}
                        onClick={() => setShow(false)}
                      >
                        <CalendarCheck size={18} className="me-2" /> Take Attendance
                      </Link>
                      <Link
                        to="/ViewTeacherAttendance"
                        className={`nav-link text-start text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/ViewTeacherAttendance'))}`}
                        onClick={() => setShow(false)}
                      >
                        <FaEye size={18} className="me-2" /> View Attendance
                      </Link>
                      <Link
                        to="/ViewLeave"
                        className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/ViewLeave'))}`}
                        onClick={() => setShow(false)}
                      >
                        <CalendarMinus size={18} className="me-2" /> View Leave Request
                      </Link>
                      </>
                     )}
                      </div>
                    </Collapse>
                  </>
                )}

                {/* Users Dropdown */}
                {(user?.user_type == 'admin'|| user?.roles?.includes('admin')) && (
                  <>
                <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('user'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('user')}
                >
                  <span>
                    <FaUser size={20} className="me-2" /> Users
                  </span>
                  {openDropdown === 'user' ? (
                    <ChevronUp />
                  ) : (
                    <ChevronDown />
                  )}
                </Button>
                <Collapse in={openDropdown === 'user'}>
                  <div>
                    <Link
                      to="/AddUser"
                      className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isRouteActive('/AddUser') || location.pathname.includes('/Assign/UserRole'))}`}
                      onClick={() => setShow(false)}
                    >
                      <People size={18} className="me-2" /> Manage Users
                    </Link>
                   </div>
                </Collapse>
                  </>
                )}


                {/* <Button
                  variant="dark"
                  className="text-black w-100 text-start d-flex justify-content-between align-items-center py-2"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                  onClick={() => toggleDropdown('teacher')}
                >
                  <span>
                    <FaChalkboardTeacher size={20} className="me-2" /> Teacher
                  </span>
                  {openDropdown === 'teacher' ? <ChevronUp /> : <ChevronDown />}
                </Button>
                <Collapse in={openDropdown === 'teacher'}>
                  <div>
                    {user?.user_type !== 'teacher' && (
                      <Link
                        to="/TeacherList"
                        className={`nav-link text-muted ps-4 ${isTeacherListActive() ? 'active' : ''}`}
                        onClick={() => setShow(false)}
                      >
                        <FaUserTie size={18} className="me-2" /> Teacher List
                      </Link>
                    )}
                    <Link
                      to="/AssignClass"
                      className="nav-link text-black ps-4"
                      onClick={() => setShow(false)}
                    >
                      <FaUserTie size={18} className="me-2" /> Class Assign
                    </Link>
                  </div>
                </Collapse> */}

               {canManageGuardiansNav && (
                <>
                  <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('guardian'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => toggleDropdown('guardian')}
                  >
                    <span>
                      <FaUser size={20} className="me-2" /> Guardians
                    </span>
                    {openDropdown === 'guardian' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'guardian'}>
                    <div>
                      <Link
                        to="/AddGuardian"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/AddGuardian'))}`}
                        onClick={() => setShow(false)}
                      >
                        <FaUser size={18} className="me-2" />
                        Manage Guardians
                      </Link>
                    </div>
                  </Collapse>
                </>
              )} 

                {(user?.user_type == 'admin'|| user?.roles?.includes('admin') || user?.user_type == 'marketer') && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('enquiry'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('enquiry')}
                    >
                      <span>
                        <ChatDots size={20} className="me-2" /> Enquiries
                      </span>
                      {openDropdown === 'enquiry' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'enquiry'}>
                      <div>
                        <Link
                          to="/EnquiryForm"
                          className={`nav-link text-muted ps-4 ${mobileOffcanvasActive(isEnquiryActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <ChatDots size={18} className="me-2" /> Manage Enquiries
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}

                {/* Notification Dropdown */}
                {canManageAnnouncementsNav && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('notification'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('notification')}
                    >
                      <span>
                        <Bell size={20} className="me-2" /> Notification
                      </span>
                      {openDropdown === 'notification' ? <ChevronUp /> : <ChevronDown />}
                    </Button>
                    <Collapse in={openDropdown === 'notification'}>
                      <div> 
                        {/* create notification comment off  */}
                        {/* <Link
                          to="/Notifications"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isCreateNotificationActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <Bell size={18} className="me-2" /> Create Notification
                        </Link> */}
                        <Link
                          to="/announcements"
                          className={`text-start nav-link text-black ps-4 ${mobileOffcanvasActive(isCreateAnnouncementActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <Bell size={18} className="me-2" /> Create Announcement
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )}



                {/* Transport Dropdown — admins: full menu + Track Vehicle; attendants: Attendant portal */}
               {showTransportNavSection && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('transport'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('transport')}
                    >
                      <span>
                        <FaBus size={20} className="me-2" /> Transport
                      </span>
                      {openDropdown === 'transport' ? <ChevronUp /> : <ChevronDown />}
                    </Button>
                    <Collapse in={openDropdown === 'transport'}>
                      <div>
                        {isAdminUser ? (
                          <Link
                            to="/Transport"
                            className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isManageBusActive())}`}
                            onClick={() => setShow(false)}
                          >
                            <FaBus size={18} className="me-2" /> Manage Transport
                          </Link>
                        ) : null}
                        <Link
                          to="/AttendantPortal"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isAttendantPortalActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <FaMapMarkerAlt size={18} className="me-2" /> Attendant Lists
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )} 

                  {showExamManagementNavSection && (
                  <>
                    <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('examMarksheet'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('examMarksheet')}
                    >
                      <span>
                        <FaPenAlt size={20} className="me-2" /> Exam Management
                      </span>
                      {openDropdown === 'examMarksheet' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'examMarksheet'}>
                      <div>
                        {!isTeacherPortalUser && (
                          <Link
                            to="/ExamSheet"
                            className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isExamSheetManageActive())}`}
                            onClick={() => setShow(false)}
                          >
                            <FaClipboardList size={18} className="me-2" /> Manage Exams
                          </Link>
                        )}
                        <Link
                          to="/AddExamResult"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/AddExamResult'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaGraduationCap size={18} className="me-2" /> Create
                          Marksheet
                        </Link>
                        <Link
                          to="/ExamMarksheet"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(mobileMatchPath('/ExamMarksheet'))}`}
                          onClick={() => setShow(false)}
                        >
                          <FaFileInvoice size={18} className="me-2" /> View
                          Marksheet
                        </Link>
                        {!isTeacherPortalUser && (
                          <Link
                            to="/ExamSheet/Admitcard"
                            className={`nav-link text-black ps-4 ${mobileOffcanvasActive(
                              location.pathname === '/ExamSheet/Admitcard' ||
                                location.pathname.startsWith('/ExamSheet/Admitcard/'),
                            )}`}
                            onClick={() => setShow(false)}
                          >
                            <PersonBadge size={18} className="me-2" /> Print Admit Card
                          </Link>
                        )}
                        {isAdminUser && (
                          <Link
                            to="/ExamSheet/BulkAdmitcard"
                            className={`nav-link text-black ps-4 ${mobileOffcanvasActive(
                              location.pathname === '/ExamSheet/BulkAdmitcard' ||
                                location.pathname.startsWith('/ExamSheet/BulkAdmitcard/'),
                            )}`}
                            onClick={() => setShow(false)}
                          >
                            <Printer size={18} className="me-2" /> Print Bulk
                            <br />
                            Admit Card
                          </Link>
                        )}
                      </div>
                    </Collapse>
                  </>
                )}

                {canAccessHomeworkNav && (
                  <>
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('homework'))}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('homework')}
                    >
                      <span>
                        <JournalBookmark size={20} className="me-2" /> Homework
                      </span>
                      {openDropdown === 'homework' ? <ChevronUp /> : <ChevronDown />}
                    </Button>
                    <Collapse in={openDropdown === 'homework'}>
                      <div>
                        <Link
                          to="/homework"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isHomeworkListActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <JournalBookmark size={18} className="me-2" /> Homework
                        </Link>
                        {canCreateHomeworkNav && (
                          <Link
                            to="/homework/create"
                            className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isHomeworkCreateActive())}`}
                            onClick={() => setShow(false)}
                          >
                            <FaPenAlt size={18} className="me-2" /> Create Homework
                          </Link>
                        )}
                      </div>
                    </Collapse>
                  </>
                )}

                {isTeacherPortalUser && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/ManageHolidays'))}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => {
                      navigate('/ManageHolidays')
                      setShow(false)
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={20} className="me-2" /> Holidays
                    </div>
                  </Button>
                )}

                {isTeacherPortalUser && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/TakeLeave'))}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => {
                      navigate('/TakeLeave')
                      setShow(false)
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarMinus size={20} className="me-2" /> Take Leave
                    </div>
                  </Button>
                )}

                {isTeacherPortalUser && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start justify-content-between align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/ChangePassword'))}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/ChangePassword')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUnlockAlt size={20} className="me-2" /> Change Password
                    </div>
                  </Button>
                )}


                  {/* Certificate Dropdown */}
                  {showCertificateNavSection && (
                    <>
              <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('certificate'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={() => toggleDropdown('certificate')}
              >
                <span>
                  <Award size={20} className="me-2" /> Certificates
                </span>
                {openDropdown === 'certificate' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'certificate'}>
                <div>
                  <Link
                    to="/Certificate"
                    className={`nav-link nav-link text-black ps-5 py-2 d-flex align-items-center ${mobileOffcanvasActive(isMobileCertificateGenerateActive())}`}
                    onClick={()=>setShow(false)}
                  >
                    <Award size={18} className="me-2" /> Generate Certificate
                  </Link>
                  <Link
                    to="/TransferCertificate"
                    className={`nav-link nav-link text-black ps-5 py-2 d-flex align-items-center ${mobileOffcanvasActive(
                      isRouteActive('/TransferCertificate') ||
                      location.pathname.startsWith('/TransferCertificate/') ||
                      isRouteActive('/GenerateTC')
                    )}`}
                    onClick={()=>setShow(false)}
                  >
                    <Award size={18} className="me-2" /> Transfer Certificate
                  </Link>
                  {/* <Link
                    to="/TemplateAssignment"
                    className={`nav-link nav-link text-black ps-5 py-2 d-flex align-items-center text-start ${mobileOffcanvasActive(isRouteActive('/TemplateBasedCertificate'))}`}
                    onClick={()=>setShow(false)}
                  >
                    <Award size={18} className="me-2" /> Manage Templates
                  </Link>
                  <Link
                    to="/TemplateBasedCertificate"
                    className={`nav-link nav-link text-black ps-5 py-2 d-flex align-items-center text-start ${mobileOffcanvasActive(isRouteActive('/TemplateBasedCertificate'))}`}
                    onClick={()=>setShow(false)}
                  >
                    <Award size={18} className="me-2" /> Template-Based
                  </Link> */}
                </div>
              </Collapse>
                    </>
                  )}
                  {(user?.user_type =="admin" || user?.roles?.includes('admin')) && (
                    <Button
                      variant="dark"
                      className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(
                        isRouteActive('/Templates') || location.pathname.startsWith('/EditTemplate/'),
                      )}`}
                      style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => {
                        navigate('/Templates')
                        setShow(false)
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <FileEarmarkText size={20} className="me-2" /> Templates
                      </div>
                    </Button>
                  )}
                  {(user?.user_type =="admin" || user?.roles?.includes('admin')) && (
                    <>
              <Button
                variant="dark"
                className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('holiday'))}`}
                style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={() => toggleDropdown('holiday')}
              >
                <span>
                  <CalendarCheck size={20} className="me-2" /> Holiday
                </span>
                {openDropdown === 'holiday' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'holiday'}>
                <div>
                  <Link
                    to="/ManageHolidays"
                    className={`nav-link nav-link text-black ps-5 py-2 d-flex align-items-center ${mobileOffcanvasActive(isRouteActive('/ManageHolidays'))}`}
                    onClick={() => setShow(false)}
                  >
                    <CalendarCheck size={18} className="me-2" /> Manage holidays
                  </Link>
                </div>
              </Collapse>
                    </>
                  )}

                {/* {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                  <>
                    <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(isMobileSettingsActive())}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                      onClick={() => toggleDropdown('settings')}
                    >
                      <span>
                        <Settings size={20} className="me-2" /> Settings
                      </span>
                      {openDropdown === 'settings' ? (
                        <ChevronUp />
                      ) : (
                        <ChevronDown />
                      )}
                    </Button>
                    <Collapse in={openDropdown === 'settings'}>
                      <div>
                        <Link
                          to="/settings"
                          className={`nav-link text-black ps-4 ${mobileOffcanvasActive(isMobileSettingsActive())}`}
                          onClick={() => setShow(false)}
                        >
                          <Settings size={18} className="me-2" /> Settings
                        </Link>
                      </div>
                    </Collapse>
                  </>
                )} */}

                {/* Parent Query List - Mobile */}      
{(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
<Button
  variant="dark"
  className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/admin-parent-queries'))}`}
  style={{ backgroundColor: 'transparent', border: 'none' }}
  // onClick={() => { window.location.href = '/admin-parent-queries'; setShow(false); }}
  onClick={() => { navigate('/admin-parent-queries'); setShow(false); }}
>
  <div className="d-flex align-items-center">
    <QuestionCircle size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
    <span>Parent Query List</span>
  </div>
</Button>
)}
                {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none subscription-nav-item ${mobileOffcanvasActive(isSubscriptionActive())}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { navigate('/admin/subscription'); setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <CreditCard size={20} className="me-2" />
                      <span>Subscription</span>
                    </div>
                  </Button>
                )}

                 {isParentPortalUser && (
                  <>
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(
                      isRouteActive('/parent/homework') || isRouteActive('/parent/homework'),
                    )}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { window.location.href = '/parent/homework'; setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <JournalBookmark size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Homework</span>
                    </div>
                  </Button>
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(
                      isRouteActive('/parent/holidays') || isRouteActive('/parent/holidays'),
                    )}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { window.location.href = '/parent/holidays'; setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Holidays</span>
                    </div>
                  </Button>
                  <Button
                    variant="dark"
                    className={`text-black w-100 text-start d-flex align-items-center py-2 text-decoration-none ${mobileOffcanvasActive(isRouteActive('/parent/bus/allocation'))}`}
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => { window.location.href = '/parent/bus/allocation'; setShow(false); }}
                  >
                    <div className="d-flex align-items-center">
                      <FaBus size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Bus Tracking</span>
                    </div>
                  </Button>
                  <Button
                  variant="dark"
                  className={`text-black w-100 text-start d-flex justify-content-between align-items-center py-2 ${mobileOffcanvasActive(hasActiveChild('support'))}`}
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => toggleDropdown('support')}
                  >
                    <div className="d-flex align-items-center">
                      <QuestionCircle size={20} className="me-2" style={{ minWidth: 20, flexShrink: 0 }} />
                      <span>Support</span>
                    </div>
                    {openDropdown === 'support' ? (
                      <ChevronUp />
                    ) : (
                      <ChevronDown />
                    )}
                  </Button>
                  <Collapse in={openDropdown === 'support'}>
                    <div>
                     <Link
  to="/parent/raise-query"
  className={`nav-link text-black ps-4 d-flex align-items-center ${mobileOffcanvasActive(isRouteActive('/parent/raise-query'))}`}
  onClick={() => setShow(false)}
>
  <QuestionCircle size={16} className="me-2" />
  Raise Query
</Link>
<Link
  to="/parent/my-queries"
  className={`nav-link text-black ps-4 d-flex align-items-center ${mobileOffcanvasActive(isRouteActive('/parent/my-queries'))}`}
  onClick={() => setShow(false)}
>
  <QuestionCircle size={16} className="me-2" />
  My Queries
</Link>
                    </div>
                  </Collapse>
                  </>
                  )}
                  {/* Parent Portal */}
 
                     {/* {user?.user_type !== 'parent' && ( 
                   <Button
                    variant="dark"
                    className="text-black w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/parent/student/list')}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} className="me-2" />
                      <span>Profile</span>
                    </div>
                  </Button> 
               )}  */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="dark"
                    className="text-black w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/Student/Attendance')}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={20} className="me-2" />
                      <span>Attendance</span>
                    </div>
                  </Button> */}
                {/* )} */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="dark"
                    className="text-black w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/Student/Fees')}
                  >
                    <div className="d-flex align-items-center">
                      <CurrencyRupee size={20} className="me-2" />
                      <span>Fees</span>
                    </div>
                  </Button> */}
                {/* )} */}

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="dark"
                    className="text-black w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/Student/Course')}
                  >
                    <div className="d-flex align-items-center">
                      <FaBookOpen size={20} className="me-2" />
                      <span>Course</span>
                    </div>
                  </Button> */}
                {/* )} */}
                <button
                  onClick={() => {
                    setShow(false)
                    handleLogout()
                  }}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#223843',
                    color: '#ffffff',
                    fontWeight: '600',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    marginTop: '10px',
                    justifyContent: 'center',
                  }}
                >
                  <BoxArrowRight size={18} />
                  <span>Logout</span>
                </button>

              </Nav>
            </Offcanvas.Body>
          </Offcanvas>

      {/* Sidebar for Desktop View — width 0 so it does not offset app-main-content;
          pages already clear the fixed sidebar via their own marginLeft. */}
      <div
        className="d-none d-lg-block"
        style={{
          width: 0,
          minWidth: 0,
          maxWidth: 0,
          flexShrink: 0,
          minHeight: '100vh',
          position: 'relative',
          zIndex: 1000,
          overflow: 'visible',
        }}
      >
        <Navbar
          expand="lg"
          className={`flex-column shadow w-auto ${isCollapsed ? 'sidebar-collapsed' : ''}`}
          style={{
            width: isCollapsed ? '85px' : '245px',
            height: '100vh',
            padding: isCollapsed ? '0.5rem 0.25rem' : '1rem',
            paddingRight: isCollapsed ? '0.25rem' : '1rem',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'fixed',
            top: 0,
            left: 0,
            backgroundColor: '#F3F4F6',
            background: '#F3F4F6',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            zIndex: 1000,
            transition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            willChange: 'width, padding',
            WebkitTransition: 'width 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1)',

            display: "flex",
            flexDirection: "column",
          }}
        >





          <Container 
            className="d-flex flex-column" 
            style={{ 
              height: '100vh',
              position: 'relative',
              padding: 0,
            }}
          >
            {/* Modern Sidebar Header Section */}
            <div
              className="sidebar-header-section"
              style={{
                position: 'sticky',
                top: 0,
                zIndex: 2,
                backgroundColor: '#F3F4F6',
                flexShrink: 0,
                width: '100%',
                marginBottom: '16px',
                paddingBottom: '10px',
                paddingLeft: isCollapsed ? '4px' : '0',
                paddingRight: isCollapsed ? '4px' : '0',
                borderBottom: '1px solid #D1D3D4',
                display: 'flex',
                flexDirection: 'column',
                alignItems: isCollapsed ? 'center' : 'stretch',
                justifyContent: 'center',
              }}
            >
              {/* Sidebar Toggle Button */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  width: '100%',
                  marginTop: isCollapsed ? '8px' : '0',
                  paddingBottom: '12px',
                  transition: 'all 0.3s ease',
                }}
              >
                <SidebarToggle />
              </div>

              {/* Modern Header Card — keep Switch Institute visible even when institute needs a plan */}
              {user?.user_type == "admin" && (
                <div
                  style={{
                    width: '100%',
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    border: '1px solid #D1D3D4',
                    padding: isCollapsed ? '8px' : '12px',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    overflow: 'hidden',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                  }}
                  title={isCollapsed ? instituteFullNameTitle : undefined}
                >
                  {isCollapsed ? (
                    /* Collapsed State - Icon Only */
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        variant="link"
                        onClick={handleOpenModal}
                        className="no-print"
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          padding: '0',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title={instituteFullNameTitle}
                      >
                        <FaExchangeAlt size={16} />
                      </Button>
                    </div>
                  ) : (
                    /* Expanded State - Full Header */
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                      }}
                    >
                      {/* Institute Info Section */}
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '10px',
                        }}
                        title={instituteFullNameTitle}
                      >
                        {/* Institute Icon/Avatar */}
                        <div
                          style={{
                            width: '36px',
                            height: '36px',
                            borderRadius: '50%',
                            backgroundColor: '#223843',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                            overflow: 'hidden',
                          }}
                          title={instituteFullNameTitle}
                        >
                          {/* <FaSchool size={16} style={{ color: '#ffffff' }} /> */}
                          <img
                            src={logo}
                            alt="Institute Logo"
                            title={instituteFullNameTitle}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </div>
                        
                        {/* Institute Name */}
                        <div
                          style={{
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                          }}
                          title={instituteFullNameTitle}
                        >
                          <p
                            style={{
                              ...instituteNameTextStyle,
                              fontSize: '12px',
                              lineHeight: '1.3',
                            }}
                            title={instituteFullNameTitle}
                          >
                            {instituteDisplayLabel}
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: '10px',
                              color: '#6b7280',
                              fontWeight: '400',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              lineHeight: '1.2',
                              fontFamily: 'Inter, system-ui, sans-serif',
                            }}
                          >
                            Current Institute
                          </p>
                        </div>
                      </div>

                      {/* Switch Institute Button */}
                      <Button
                        variant="link"
                        onClick={handleOpenModal}
                        className="no-print"
                        style={{
                          width: '100%',
                          backgroundColor: '#F3F4F6',
                          border: '1px solid #D1D3D4',
                          color: '#223843',
                          fontSize: '11px',
                          fontWeight: '600',
                          padding: '8px 10px',
                          borderRadius: '8px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '6px',
                          textDecoration: 'none',
                          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                          fontFamily: 'Inter, system-ui, sans-serif',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.color = '#ffffff'
                          e.currentTarget.style.borderColor = '#223843'
                          e.currentTarget.style.transform = 'translateY(-1px)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#F3F4F6'
                          e.currentTarget.style.color = '#223843'
                          e.currentTarget.style.borderColor = '#D1D3D4'
                          e.currentTarget.style.transform = 'translateY(0)'
                        }}
                      >
                        <FaExchangeAlt size={12} />
                        <span>Switch Institute</span>
                      </Button>
                    </div>
                  )}
                  {showModal &&
                    <NewInstituteSelectionModal show={showModal} onClose={handleCloseModal} />}
                </div>
              )}
            </div>


            {/* Scrollable Menu Section */}
            <Nav 
              className={`flex-column w-100 sidebar-scrollable${subscriptionOnlyMode ? ' subscription-only-nav' : ''}`}
              style={{
                flex: '1 1 auto',
                overflowY: 'auto',
                overflowX: 'hidden',
                transition: 'all 0.3s ease',
                paddingRight: '5px',
                marginRight: '-5px',
                minHeight: 0,
              }}
            >
              {subscriptionOnlyMode && !isAdminUser && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn subscription-nav-item ${isCollapsed ? 'justify-content-center' : ''} ${isSubscriptionActive() ? 'active' : ''} text-decoration-none mt-3`}
                  onClick={() => navigate('/admin/subscription')}
                  title={isCollapsed ? 'Subscription' : ''}
                >
                  <div className="d-flex align-items-center">
                    <CreditCard size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Subscription</span>}
                  </div>
                </Button>
              )}
              {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/Dashboard') ? 'active' : ''} text-decoration-none mt-3`}
                  onClick={() => (window.location.href = '/Dashboard')}
                  title={isCollapsed ? 'Dashboard' : ''}
                >
                  <div className="d-flex align-items-center">
                    <FaTachometerAlt size={20} className="nav-button-icon" style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    <span className="nav-button-text">Dashboard</span>
                  </div>
                </Button>
              )}

              {user?.user_type === 'parents' && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/parent/dashboard') ? 'active' : ''} text-decoration-none mt-3`}
                  onClick={() => (window.location.href = '/parent/dashboard')}
                  title={isCollapsed ? 'Dashboard' : ''}
                >
                  <div className="d-flex align-items-center">
                    <FaTachometerAlt size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Dashboard</span>}
                  </div>
                </Button>
              )}

              {/* {user?.user_type === 'parents' && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/updates') ? 'active' : ''} text-decoration-none mt-3`}
                  onClick={() => (window.location.href = '/updates')}
                  title={isCollapsed ? 'Updates' : ''}
                >
                  <div className="d-flex align-items-center">
                    <Bell size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Updates</span>}
                  </div>
                </Button>
              )} */}

               {!isFeesCollectorOnly && !isAttendantOnlyUser && <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isTopAnnouncementsActive() ? 'active' : ''} text-decoration-none mt-3`}
                  onClick={() => (window.location.href = topAnnouncementsHref)}
                  title={isCollapsed ? 'TopAnnouncements' : ''}
                >
                  <div className="d-flex align-items-center">
                    <Bell size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Announcements</span>}
                  </div>
                </Button>}
              {/* Students Dropdown */}
              {canManageStudentsNav && (
                <>
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('students') ? 'active' : ''} text-decoration-none`}
                  onClick={() => toggleDropdown('students')}
                  title={isCollapsed ? 'Students' : ''}
                >
                  <div className="d-flex align-items-center">
                    <Person size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Students</span>}
                  </div>
                  {!isCollapsed && (openDropdown === 'students' ? (
                    <ChevronUp size={16} />
                  ) : (
                    <ChevronDown size={16} />
                  ))}
                </Button>
                {!isCollapsed && (
                  <Collapse in={openDropdown === 'students'}>
                    <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    <Link
                      to="/students"
                      className={`sidebar-child-link ${isAddStudentActive() ? 'active' : ''}`}
                    >
                      <People size={16} />
                      <span>Active Students</span>
                    </Link>
                    <Link
                      to="/student/discharged"
                      className={`sidebar-child-link ${isDischargedStudentActive() ? 'active' : ''}`}
                    >
                      <FaUserSlash size={16} />
                      <span>Left Students</span>
                    </Link>
                    <Link
                      to="/students/passed-out"
                      className={`sidebar-child-link text-start ${isPassedOutStudentActive() ? 'active' : ''}`}
                    >
                      <FaUserGraduate size={16} />
                      <span>Passed Out Students</span>
                    </Link>
                    </div>
                  </Collapse>
                )}
                </>
              )}

              {(normalizedUserType === 'teacher' && !canManageStudentsNav) && (
                <>
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('teacherstudents') ? 'active' : ''} text-decoration-none`}
                  onClick={() => toggleDropdown('teacherstudents')}
                  title={isCollapsed ? 'Students' : ''}
                >
                  <div className="d-flex align-items-center">
                    <Person size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Student</span>}
                  </div>
                  {!isCollapsed && (openDropdown === 'teacherstudents' ? (
                    <ChevronUp size={16} />
                  ) : (
                    <ChevronDown size={16} />
                  ))}
                </Button>
                {!isCollapsed && (
                  <Collapse in={openDropdown === 'teacherstudents'}>
                    <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                      <Link
                        to="/TeacherStudent"
                        className={`sidebar-child-link ${isRouteActive('/TeacherStudent') ? 'active' : ''}`}
                      >
                        <People size={16} />
                        <span>Active Students</span>
                      </Link>
                      {(user?.user_type == 'admin' || user?.roles?.includes('admin'))&& (
                        <Link
                          to="/student/discharged"
                          className={`sidebar-child-link ${isDischargedStudentActive() ? 'active' : ''}`}
                        >
                          <FaUserSlash size={16} />
                          <span>Left Students</span>
                        </Link>
                      )}
                    </div>
                  </Collapse>
                )}
                </>
              )}
              
               {canManageCoursesNav && (
                <>
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('courseList') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('courseList')}
                    title={isCollapsed ? 'Course' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaBookOpen size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Courses</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'courseList' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>

                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'courseList'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        <Link
                          to="/AddCourse"
                          className={`sidebar-child-link ${isRouteActive('/AddCourse') ? 'active' : ''}`}
                        >
                          <FaBookOpen size={16} />
                          <span>Manage Courses</span>
                        </Link>
                        <Link
                          to="/AddSubject"
                          className={`sidebar-child-link ${isRouteActive('/AddSubject') ? 'active' : ''}`}
                        >
                          <FaBookOpen size={16} />
                          <span>Manage Subjects</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )}


              {canManageClassesNav && (
                <>
                     <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('classes') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('classes')}
                title={isCollapsed ? 'Classes' : ''}
              >
                <div className="d-flex align-items-center">
                  <FaChalkboard size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Classes</span>}
                </div>
                {!isCollapsed && (openDropdown === 'classes' ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
              </Button>
              {!isCollapsed && (
                <Collapse in={openDropdown === 'classes'}>
                  <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    <Link
                      to="/AddClass"
                      className={`sidebar-child-link ${isRouteActive('/AddClass') ? 'active' : ''}`}
                    >
                      <FaChalkboard size={16} />
                      <span>Manage Class</span>
                    </Link>
                  </div>
                </Collapse>
              )}

</>
              )}
         
              {/* Fees Dropdown */}

              {canAccessFeesManagement && (
                <>
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('feesManagement') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('feesManagement')}
                    title={isCollapsed ? 'Fees Management' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <CreditCard size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Fees Management</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'feesManagement' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>

                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'feesManagement'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        {canAccessFullFeesManagement && (
                          <>
                            <Link
                              to="/FeeStructure"
                              className={`sidebar-child-link ${isRouteActive('/FeeStructure') ? 'active' : ''}`}
                            >
                              <CreditCard size={16} />
                              <span>Fee Structure</span>
                            </Link>
                            <Link
                              to="/ApplyFees"
                              className={`sidebar-child-link ${isRouteActive('/ApplyFees') ? 'active' : ''}`}
                            >
                              <CreditCard size={16} />
                              <span>Apply Fee</span>
                            </Link>
                            <Link
                              to="/FeeCollection"
                              className={`sidebar-child-link ${isRouteActive('/FeeCollection') ? 'active' : ''}`}
                            >
                              <CurrencyRupee size={16} />
                              <span>Fee Collection</span>
                            </Link>
                            <Link
                              to="/FeeUpdateLogs"
                              className={`sidebar-child-link ${isRouteActive('/FeeUpdateLogs') ? 'active' : ''}`}
                            >
                              <FaClipboardList size={16} />
                              <span>Fee Update Logs</span>
                            </Link>
                          </>
                        )}
                        {canAccessCollectorLimitedFees && (
                          <>
                            <Link
                              to="/TakeFees"
                              className={`sidebar-child-link ${isRouteActive('/TakeFees') ? 'active' : ''}`}
                            >
                              <CurrencyRupee size={16} />
                              <span>Take Fees</span>
                            </Link>
                            <Link
                              to="/ManageStudentFees"
                              className={`sidebar-child-link ${isRouteActive('/ManageStudentFees') ? 'active' : ''}`}
                            >
                              <CurrencyRupee size={16} />
                              <span>Fees Status</span>
                            </Link>
                          </>
                        )}
                        <Link
                          to="/PendingFee"
                          className={`sidebar-child-link ${isRouteActive('/PendingFee') ? 'active' : ''}`}
                        >
                          <FaExclamationTriangle size={16} />
                          <span>Pending Fee</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {/* Institute Dropdown */}
               {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                <>
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('institute') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('institute')}
                    title={isCollapsed ? 'Institute' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaUniversity size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Institutes</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'institute' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'institute'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        <Link
                          to="/AddInstitute"
                          className={`sidebar-child-link text-start ${isRouteActive('/AddInstitute') ? 'active' : ''}`}
                        >
                          <FaUniversity size={16} />
                          <span>Manage Institutes</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {/* Attendance Dropdown */}
             {(isAdminUser || isTeacherPortalUser) && (
<>

<Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('attendance') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('attendance')}
                title={isCollapsed ? 'Attendance' : ''}
              >
                <div className="d-flex align-items-center">
                  <ClipboardCheck size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Attendance</span>}
                </div>
                {!isCollapsed && (openDropdown === 'attendance' ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                ))}
              </Button>
              {!isCollapsed && (
                <Collapse in={openDropdown === 'attendance'}>
                  <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    <Link
                      to="/TakeAttendance"
                      className={`sidebar-child-link ${isRouteActive('/TakeAttendance') ? 'active' : ''}`}
                    >
                      <CalendarCheck size={16} />
                      <span>Take Attendance</span>
                    </Link>
                    <Link
                      to="/ViewAttendance"
                      className={`sidebar-child-link ${isRouteActive('/ViewAttendance') ? 'active' : ''}`}
                    >
                      <FaEye size={16} />
                      <span>View Attendance</span>
                    </Link>
                  </div>
                </Collapse>
              )}
              </>
              )}
              

              
              {/* Fees Dropdown */}
              {/* <Button
                  variant="dark"
                  className="text-muted w-100 text-start d-flex justify-content-between align-items-center py-2"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={() => toggleDropdown("fees")}
              >
                <span>
                  <CurrencyRupee size={20} className="me-2" />
                  Fees
                </span>
                {openDropdown === "fees" ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === "fees"}>
                <div>
                  <Link
                    to="/TakeFees"
                    className="nav-link nav-link text-muted ps-5 py-2 d-flex align-items-center"
                  >
                    <CurrencyRupee size={18} className="me-2" />
                    Take Fees
                  </Link>
                </div>
              </Collapse> */}

              {/* Teacher Dropdown */}

              {/* {user?.user_type !== 'teacher' && ( */}
              {(user?.user_type == 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || user?.roles?.includes('teacher')) && (
                  <>
                  
              <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('teacher') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('teacher')}
                title={isCollapsed ? 'Teacher' : ''}
              >
                <div className="d-flex align-items-center">
                  <FaChalkboardTeacher size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Teachers</span>}
                </div>
                {!isCollapsed && (openDropdown === 'teacher' ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
              </Button>
              {!isCollapsed && (
                <Collapse in={openDropdown === 'teacher'}>
                  <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    
                    {(user?.user_type !== 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || !user?.roles?.includes('teacher')) && (
                      <Link
                        to="/TeacherList"
                        className={`sidebar-child-link ${isTeacherListActive() ? 'active' : ''}`}
                      >
                        <FaChalkboardTeacher size={16} />
                        <span>Manage Teachers</span>
                      </Link>
                    )}
                    {(user?.user_type !== 'teacher' || user?.user_type == 'admin' || user?.roles?.includes('admin') || !user?.roles?.includes('teacher')) && (
                      <Link
                        to="/LeftTeachers"
                        className={`sidebar-child-link ${isLeftTeachersActive() ? 'active' : ''}`}
                      >
                        <FaUserSlash size={16} />
                        <span>Left Teachers</span>
                      </Link>
                    )}

                    <Link
                      to="/AssignClass"
                      className={`sidebar-child-link ${isRouteActive('/AssignClass') ? 'active' : ''}`}
                    >
                      <FaUserTie size={16} />
                      <span>Assign Class</span>
                    </Link>
                    {isTeacherPortalUser && (
                      <Link
                        to="/MyAttendance"
                        className={`sidebar-child-link ${isRouteActive('/MyAttendance') ? 'active' : ''}`}
                      >
                        <ClipboardCheck size={16} />
                        <span>My Attendance</span>
                      </Link>
                    )}
                    {isAdminUser && (
                      <Link
                        to="/TakeTeacherAttendance"
                        className={`sidebar-child-link ${isRouteActive('/TakeTeacherAttendance') ? 'active' : ''}`}
                      >
                        <CalendarCheck size={16} />
                        <span>Take Attendance</span>
                      </Link>
                    )}
                    {isAdminUser && (
                      <Link
                        to="/ViewTeacherAttendance"
                        className={`sidebar-child-link ${isRouteActive('/ViewTeacherAttendance') ? 'active' : ''}`}
                      >
                        <FaEye size={16} />
                        <span>View Attendance</span>
                      </Link>
                    )}
                    {isAdminUser && (
                      <Link
                        to="/ViewLeave"
                        className={`sidebar-child-link ${isRouteActive('/ViewLeave') ? 'active' : ''}`}
                      >
                        <CalendarMinus size={16} />
                        <span>View Leave Request</span>
                      </Link>
                    )}
                  </div>
                </Collapse>
              )}
              </>
                )}

                   {(user?.user_type == 'admin'|| user?.roles?.includes('admin')) && (
                  <>
                     <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('user') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('user')}
                title={isCollapsed ? 'User' : ''}
              >
                <div className="d-flex align-items-center">
                  <FaUser size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Users</span>}
                </div>
                {!isCollapsed && (openDropdown === 'user' ? <ChevronUp size={16} /> : <ChevronDown size={16} />)}
              </Button>
                    {!isCollapsed && (
                      <Collapse in={openDropdown === 'user'}>
                        <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                          <Link 
                          to="/AddUser"
                          className={`sidebar-child-link ${isRouteActive('/AddUser') || location.pathname.includes('/Assign/UserRole') ? 'active' : ''}`}>
                            <People size={16} />
                            <span>Manage Users</span>
                          </Link>
                        </div>
                      </Collapse>
                    )}
               </>
                           )}
                
                {/* Guardian Dropdown */}
               {canManageGuardiansNav && (
                <>
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('guardian') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('guardian')}
                    title={isCollapsed ? 'Guardian' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Guardians</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'guardian' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'guardian'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }} className='text-start'>
                        <Link
                          to="/AddGuardian"
                          className={`sidebar-child-link ${isRouteActive('/AddGuardian') ? 'active' : ''}`}
                        >
                          <FaUser size={16} />
                          <span>Manage Guardians</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )} 

              {/* )} */}

              {/* <Button
                  variant="dark"
                  className="text-muted w-100 text-start d-flex justify-content-between align-items-center py-2"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={() => toggleDropdown("examsheet")}
              >
                <span>
                  <FaChalkboardTeacher size={20} className="me-2" />
                  Exam Sheet
                </span>
                {openDropdown === "examsheet" ? <ChevronUp /> : <ChevronDown />}
              </Button>
              <Collapse in={openDropdown === "examsheet"}>
              <div>
                  <Link
                    to="/TeacherList"
                    className="nav-link nav-link text-muted ps-5 py-2 d-flex align-items-center"
                  >
                    <FaUserTie size={18} className="me-2" />
                    Exam Sheet
                  </Link>
                </div>
              </Collapse> */}

               {(user?.user_type == 'admin'|| user?.roles?.includes('admin') || user?.roles?.includes('marketer')) && (
                <>
                  {/* Enquiry Dropdown */}
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('enquiry') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('enquiry')}
                    title={isCollapsed ? 'Enquiry' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <ChatDots size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Enquiries</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'enquiry' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'enquiry'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        <Link
                          to="/EnquiryForm"
                          className={`sidebar-child-link text-start ${isEnquiryActive() ? 'active' : ''}`}
                        >
                          <ChatDots size={16} />
                          <span>Manage Enquiries</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {/* Notification Dropdown */}
              {canManageAnnouncementsNav && (
                <>
                  <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('notification') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('notification')}
                    title={isCollapsed ? 'Notification' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <Bell size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Notification</span>}
                    </div>
                    {!isCollapsed &&
                      (openDropdown === 'notification' ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'notification'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        {/* <Link
                          to="/Notifications"
                          className={`sidebar-child-link ${isCreateNotificationActive() ? 'active' : ''}`}
                        >
                          <Bell size={16} />
                          <span>Create Notification</span>
                        </Link> */}
                        <Link
                          to="/announcements"
                          className={`text-start sidebar-child-link ${isCreateAnnouncementActive() ? 'active' : ''}`}
                        >
                          <Bell size={16} />
                          <span>Create Announcement</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {/* Transport Dropdown — admins: full menu + Track Vehicle; attendants: Attendant portal */}
              
            {showTransportNavSection && (
                <>
                  <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('transport') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('transport')}
                    title={isCollapsed ? 'Transport' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaBus size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Transport</span>}
                    </div>
                    {!isCollapsed &&
                      (openDropdown === 'transport' ? (
                        <ChevronUp size={16} />
                      ) : (
                        <ChevronDown size={16} />
                      ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'transport'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        {isAdminUser ? (
                          <Link
                            to="/Transport"
                            className={`sidebar-child-link ${isManageBusActive() ? 'active' : ''} text-start`}
                          >
                            <FaBus size={16} />
                            <span>Manage Transport</span>
                          </Link>
                        ) : null}
                        <Link
                          to="/TrackVehicle"
                          className={`sidebar-child-link ${isAttendantPortalActive() ? 'active' : ''} text-start`}
                        >
                          <FaMapMarkerAlt size={16} />
                          <span>Attendant List</span>
                        </Link>
                      </div>
                    </Collapse>
                  )}
                </> 
              )} 

              {/* Exam Management Dropdown */}
               {showExamManagementNavSection && (
                <>
                  {' '}
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('examMarksheet') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('examMarksheet')}
                    title={isCollapsed ? 'Exam Management' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaPenAlt size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Exam Management</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'examMarksheet' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'examMarksheet'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        {!isTeacherPortalUser && (
                          <Link
                            to="/ExamSheet"
                            className={`sidebar-child-link ${isExamSheetManageActive() ? 'active' : ''}`}
                          >
                            <FaClipboardList size={16} />
                            <span>Manage Exams</span>
                          </Link>
                        )}
                        <Link
                          to="/AddExamResult"
                          className={`sidebar-child-link ${isRouteActive('/AddExamResult') ? 'active' : ''}`}
                        >
                          <FaGraduationCap size={16} />
                          <span>Create Marksheet</span>
                        </Link>
                        <Link
                          to="/ExamMarksheet"
                          className={`sidebar-child-link ${isRouteActive('/ExamMarksheet') ? 'active' : ''}`}
                        >
                          <FaFileInvoice size={16} />
                          <span>View Marksheet</span>
                        </Link>
                        {!isTeacherPortalUser && (
                          <Link
                            to="/ExamSheet/Admitcard"
                            className={`sidebar-child-link ${
                              location.pathname === '/ExamSheet/Admitcard' ||
                              location.pathname.startsWith('/ExamSheet/Admitcard/')
                                ? 'active'
                                : ''
                            }`}
                          >
                            <PersonBadge size={16} />
                            <span>Print Admit Card</span>
                          </Link>
                        )}
                        {isAdminUser && (
                          <Link
                            to="/ExamSheet/BulkAdmitcard"
                            className={`sidebar-child-link ${
                              location.pathname === '/ExamSheet/BulkAdmitcard' ||
                              location.pathname.startsWith('/ExamSheet/BulkAdmitcard/')
                                ? 'active'
                                : ''
                            }`}
                          >
                            <Printer size={16} />
                            <span>
                              Print Bulk
                              <br />
                              Admit Card
                            </span>
                          </Link>
                        )}
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {canAccessHomeworkNav && (
                <>
                  <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('homework') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('homework')}
                    title={isCollapsed ? 'Homework' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <JournalBookmark size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Homework</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'homework' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'homework'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        <Link
                          to="/homework"
                          className={`sidebar-child-link ${isHomeworkListActive() ? 'active' : ''}`}
                        >
                          <JournalBookmark size={16} />
                          <span>Homework</span>
                        </Link>
                        {canCreateHomeworkNav && (
                          <Link
                            to="/homework/create"
                            className={`text-start sidebar-child-link ${isHomeworkCreateActive() ? 'active' : ''}`}
                          >
                            <FaPenAlt size={16} />
                            <span>Create Homework</span>
                          </Link>
                        )}
                      </div>
                    </Collapse>
                  )}
                </>
              )}

              {isTeacherPortalUser && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/ManageHolidays') ? 'active' : ''} text-decoration-none`}
                  onClick={() => navigate('/ManageHolidays')}
                  title={isCollapsed ? 'Holidays' : ''}
                >
                  <div className="d-flex align-items-center">
                    <CalendarCheck size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Holidays</span>}
                  </div>
                </Button>
              )}

              {isTeacherPortalUser && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/TakeLeave') ? 'active' : ''} text-decoration-none`}
                  onClick={() => navigate('/TakeLeave')}
                  title={isCollapsed ? 'Take Leave' : ''}
                >
                  <div className="d-flex align-items-center">
                    <CalendarMinus size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Take Leave</span>}
                  </div>
                </Button>
              )}

              {/* Change Password */}

            {isTeacherPortalUser && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/ChangePassword') ? 'active' : ''} text-decoration-none`}
                  onClick={() => (window.location.href = '/ChangePassword')}
                  title={isCollapsed ? 'Change Password' : ''}
                >
                  <div className="d-flex align-items-center">
                    <FaUnlockAlt size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Change Password</span>}
                  </div>
                </Button>
              )}

              {(user?.user_type =="admin" || user?.roles?.includes('admin')) && (
                <>
                
              {/* Certificate Dropdown */}
              {showCertificateNavSection && (
                <>
              <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('certificate') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('certificate')}
                title={isCollapsed ? 'Certificate' : ''}
              >
                <div className="d-flex align-items-center">
                  <Award size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Certificates</span>}
                </div>
                {!isCollapsed && (openDropdown === 'certificate' ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                ))}
              </Button>
              {!isCollapsed && (
                <Collapse in={openDropdown === 'certificate'}>
                  <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    <Link
                      to="/Certificate"
                      className={`sidebar-child-link text-start ${isRouteActive('/Certificate') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Generate Certificate</span>
                    </Link>
                    <Link
                      to="/TransferCertificate"
                      className={`sidebar-child-link text-start ${isRouteActive('/TransferCertificate') || location.pathname.startsWith('/TransferCertificate/') || isRouteActive('/GenerateTC') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Transfer Certificate</span>
                    </Link>
                    
                    {/* <Link
                      to="/TemplateAssignment"
                      className={`sidebar-child-link text-start ${isRouteActive('/TemplateAssignment') || location.pathname.startsWith('/TransferCertificate/') || isRouteActive('/GenerateTC') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Manage Templates</span>
                    </Link>

                    <Link
                      to="/TemplateBasedCertificate"
                      className={`sidebar-child-link text-start ${isRouteActive('/TemplateBasedCertificate') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template-Based</span>
                    </Link> */}

                    
                    {/* <Link
                      to="/certificate/template1"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template1') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 1</span>
                    </Link>
                    <Link
                      to="/certificate/template2"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template2') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 2</span>
                    </Link>
                    <Link
                      to="/certificate/template3"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template3') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 3</span>
                    </Link>
                    <Link
                      to="/certificate/template4"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template4') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 4</span>
                    </Link>
                    <Link
                      to="/certificate/template5"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template5') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 5</span>
                    </Link>
                    <Link
                      to="/certificate/template6"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template6') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 6</span>
                    </Link>
                    <Link
                      to="/certificate/template7"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template7') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 7</span>
                    </Link>
                    <Link
                      to="/certificate/template8"
                      className={`sidebar-child-link text-start ${isRouteActive('/certificate/template8') ? 'active' : ''}`}
                    >
                      <Award size={16} />
                      <span>Template 8</span>
                    </Link> */}


                  </div>
                </Collapse>
              )}
                </>
              )}

              {(user?.user_type == "admin" || user?.roles?.includes('admin')) && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/Templates') || location.pathname.startsWith('/EditTemplate/') ? 'active' : ''} text-decoration-none`}
                  onClick={() => navigate('/Templates')}
                  title={isCollapsed ? 'Templates' : ''}
                >
                  <div className="d-flex align-items-center">
                    <FileEarmarkText size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Templates</span>}
                  </div>
                </Button>
              )}

              {/* Holiday Dropdown */}
              <Button
                variant="link"
                className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('holiday') ? 'active' : ''} text-decoration-none`}
                onClick={() => toggleDropdown('holiday')}
                title={isCollapsed ? 'Holiday' : ''}
              >
                <div className="d-flex align-items-center">
                  <CalendarCheck size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                  {!isCollapsed && <span className="nav-button-text">Holiday</span>}
                </div>
                {!isCollapsed && (openDropdown === 'holiday' ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                ))}
              </Button>
              {!isCollapsed && (
                <Collapse in={openDropdown === 'holiday'}>
                  <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                    <Link
                      to="/ManageHolidays"
                      className={`sidebar-child-link text-start ${isRouteActive('/ManageHolidays') ? 'active' : ''}`}
                    >
                      <CalendarCheck size={16} />
                      <span>Manage holidays</span>
                    </Link>
                  </div>
                </Collapse>
              )}

              

{/* Parent Query List */}
<Button
  variant="link"
  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/admin-parent-queries') ? 'active' : ''} text-decoration-none`}
  // onClick={() => (window.location.href = '/admin-parent-queries')}
  onClick={() => navigate('/admin-parent-queries')}
  title={isCollapsed ? 'Parent Query List' : ''}
>
  <div className="d-flex align-items-center">
    <QuestionCircle size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
    {!isCollapsed && <span className="nav-button-text">Parent Query List</span>}
  </div>
</Button>

<Button
  variant="link"
  className={`sidebar-menu-btn subscription-nav-item ${isCollapsed ? 'justify-content-center' : ''} ${isSubscriptionActive() ? 'active' : ''} text-decoration-none`}
  onClick={() => navigate('/admin/subscription')}
  title={isCollapsed ? 'Subscription' : ''}
>
  <div className="d-flex align-items-center">
    <CreditCard size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
    {!isCollapsed && <span className="nav-button-text">Subscription</span>}
  </div>
</Button>

              

</>
              )}
              {/* Student Promotion Dropdown */}
              {/* <Button
                  variant="dark"
                  className="text-muted w-100 text-start d-flex justify-content-between align-items-center py-2"
                  style={{ backgroundColor: 'transparent', border: 'none' }}
                onClick={() => toggleDropdown('studentPromotion')}
              >
                <span>
                  <ClipboardData size={20} className="me-2" /> Student Promotion
                </span>
                {openDropdown === 'studentPromotion' ? (
                  <ChevronUp />
                ) : (
                  <ChevronDown />
                )}
              </Button>
              <Collapse in={openDropdown === 'studentPromotion'}>
                <div>
                  <Link
                    to="/StudentPromotion"
                    className="nav-link nav-link text-muted ps-5 py-2 d-flex align-items-center"
                  >
                    <ClipboardData size={18} className="me-2" /> Promote Student
                  </Link>
                </div>
              </Collapse> */}

              {/* {(user?.user_type == 'admin' || user?.roles?.includes('admin')) && (
                <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/Settings') ? 'active' : ''} text-decoration-none mt-0`}
                  onClick={() => (window.location.href = '/Settings')}
                  title={isCollapsed ? 'Settings' : ''}
                >
                  <div className="d-flex align-items-center">
                    <Settings size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                    {!isCollapsed && <span className="nav-button-text">Settings</span>}
                  </div>
                </Button>
              )} */}

               {user?.user_type === 'parents' && (
                   <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/parent/student/list') ? 'active' : ''} text-decoration-none mt-0`}
                    onClick={() => (window.location.href = '/parent/student/list')}
                    title={isCollapsed ? "Student's Profile" : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaUser size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Student's Profile</span>}
                    </div>
                  </Button> 
                 )}
               {user?.user_type === 'parents' && (
                   <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/parent/homework') || isRouteActive('/parent/homework') ? 'active' : ''} text-decoration-none mt-0`}
                    onClick={() => (window.location.href = '/parent/homework')}
                    title={isCollapsed ? 'Homework' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <JournalBookmark size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Homework</span>}
                    </div>
                  </Button>
               )} 
               {isParentPortalUser && (
                   <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/parent/holidays') || isRouteActive('/parent/holidays') ? 'active' : ''} text-decoration-none mt-0`}
                    onClick={() => (window.location.href = '/parent/holidays')}
                    title={isCollapsed ? 'Holidays' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <CalendarCheck size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Holidays</span>}
                    </div>
                  </Button>
               )}
                 {user?.user_type === "parents" && (
                  <Button
                    variant="link"
                    className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${isRouteActive('/parent/bus/allocation') ? 'active' : ''} text-decoration-none mt-0`}
                    onClick={() => (window.location.href = '/parent/bus/allocation')}
                    title={isCollapsed ? 'Bus Tracking' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <FaBus size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Bus Tracking</span>}
                    </div>
                  </Button>
                 )}
                  {user?.user_type === "parents" && (
                  <>
                  <Button
                  variant="link"
                  className={`sidebar-menu-btn ${isCollapsed ? 'justify-content-center' : ''} ${hasActiveChild('support') ? 'active' : ''} text-decoration-none`}
                    onClick={() => toggleDropdown('support')}
                    title={isCollapsed ? 'Support' : ''}
                  >
                    <div className="d-flex align-items-center">
                      <QuestionCircle size={20} style={{ marginRight: isCollapsed ? '0' : '12px' }} />
                      {!isCollapsed && <span className="nav-button-text">Support</span>}
                    </div>
                    {!isCollapsed && (openDropdown === 'support' ? (
                      <ChevronUp size={16} />
                    ) : (
                      <ChevronDown size={16} />
                    ))}
                  </Button>
                  {!isCollapsed && (
                    <Collapse in={openDropdown === 'support'}>
                      <div style={{ paddingLeft: '8px', marginTop: '4px' }}>
                        <Link
                          to="/parent/raise-query"
                          className={`sidebar-child-link text-start ${isRouteActive('/parent/raise-query') ? 'active' : ''}`}
                        >
                          <QuestionCircle size={16} />
                          <span>Raise Query</span>
                        </Link>
                        <Link
                          to="/parent/my-queries"
                          className={`sidebar-child-link text-start ${isRouteActive('/parent/my-queries') ? 'active' : ''}`}
                        >
                          <QuestionCircle size={16} />
                          <span>My Queries</span>
                        </Link>
                      </div>
                      
                    </Collapse>


                  )}
                  </>
                  )}
                

                 {/* {user?.user_type !== 'parent' && ( */}
                  {/* <Button
                    variant="dark"
                    className="text-muted w-100 text-start d-flex justify-content-between align-items-center py-2 text-decoration-none mt-0"
                    style={{ backgroundColor: 'transparent', border: 'none' }}
                    onClick={() => (window.location.href = '/Student/Course')}
                  >
                    <div className="d-flex align-items-center">
                      <FaBookOpen size={20} className="me-2" />
                      <span>Course</span>
                    </div>
                  </Button> */}
                {/* )} */}
            </Nav>
          {/* ✅ Logout Button at Bottom */}
<div style={{ marginTop: "auto", width: "100%" }}>
  <button
    onClick={handleLogout}
    style={{
      width: "100%",
      padding: "10px 12px",
      borderRadius: "8px",
      border: "none",
      backgroundColor: "#223843",
      color: "#ffffff",
      fontWeight: "600",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginTop: "10px",
      justifyContent: "center",
    }}
  >
    <BoxArrowRight size={18} />
    {!isCollapsed && <span>Logout</span>}
  </button>
</div>
          </Container>
        </Navbar>
      </div>
    </>
  )
}
